// src/components/RolPlayLobby.jsx
import React from 'react';
import { PlayCircle, Clock, User, Handshake, Briefcase, Mic, ArrowLeft } from 'lucide-react';

const RolPlayLobby = ({ onSelectOption, onBackToDashboard }) => {
  return (
    <div className="px-4 py-6">
      {/* Botón de regreso */}
      {onBackToDashboard && (
        <div className="max-w-4xl mx-auto mb-4">
          <button
            onClick={onBackToDashboard}
            className="flex items-center gap-2 text-gray-600 hover:text-gray-800 transition-colors"
          >
            <ArrowLeft className="w-4 h-4" />
            <span className="text-sm">Volver al dashboard</span>
          </button>
        </div>
      )}
      
      {/* Header mejorado con claim principal y subtítulo con íconos */}
      <div className="max-w-4xl mx-auto mb-8">
        <h1 className="text-3xl font-bold text-gray-800 text-center mb-4">
          Simula. Entrena. Lidera bajo presión.
        </h1>
        <div className="hidden md:flex gap-8 justify-center items-center mt-2 mb-12">
          <span className="flex items-center gap-2 text-gray-500 text-sm">
            <User className="w-5 h-5 text-gray-500" />
            Cliente
          </span>
          <span className="flex items-center gap-2 text-gray-500 text-sm">
            <Handshake className="w-5 h-5 text-gray-500" />
            Negociación
          </span>
          <span className="flex items-center gap-2 text-gray-500 text-sm">
            <Briefcase className="w-5 h-5 text-gray-500" />
            Jefe
          </span>
          <span className="flex items-center gap-2 text-gray-500 text-sm">
            <Mic className="w-5 h-5 text-gray-500" />
            Presentación
          </span>
        </div>
      </div>
      
      {/* Grid de tarjetas - responsivo con ancho máximo y centrado */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto">
        {/* Tarjeta de Nueva Simulación */}
        <div 
          className="bg-white border border-gray-200 rounded-2xl shadow-md p-6 flex flex-col items-center h-60 transition-all duration-200 hover:border-blue-400 hover:shadow-lg cursor-pointer"
          onClick={() => onSelectOption('nueva')}
        >
          <div className="w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4 bg-blue-100">
            <PlayCircle className="w-9 h-9 text-blue-600" />
          </div>
          
          <h3 className="text-xl font-semibold text-gray-900 text-center">Nueva simulación</h3>
          <p className="text-gray-500 text-sm mt-2 text-center">
            Comienza una nueva práctica bajo presión real.
          </p>
          
          <button
            className="mt-auto bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-xl text-base font-semibold min-w-[140px] transition-colors"
          >
            Iniciar
          </button>
        </div>
        
        {/* Tarjeta de Simulaciones Pasadas */}
        <div 
          className="bg-white border border-gray-200 rounded-2xl shadow-md p-6 flex flex-col items-center h-60 transition-all duration-200 hover:border-blue-400 hover:shadow-lg cursor-pointer"
          onClick={() => onSelectOption('historial')}
        >
          <div className="w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4 bg-blue-100">
            <Clock className="w-9 h-9 text-blue-600" />
          </div>
          
          <h3 className="text-xl font-semibold text-gray-900 text-center">Simulaciones pasadas</h3>
          <p className="text-gray-500 text-sm mt-2 text-center">
            Revisa tu historial y analiza tu progreso.
          </p>
          
          <button
            className="mt-auto bg-slate-200 hover:bg-slate-300 text-slate-800 px-6 py-3 rounded-xl text-base font-semibold min-w-[140px] transition-colors"
          >
            Ver historial
          </button>
        </div>
      </div>
    </div>
  );
};

export default RolPlayLobby;
